import type { DailyPresetId, DailyComparisonPresetId } from 'components/filter/input/DateRangePicker/presets';

// ── Main range presets ────────────────────────────────────────────────────────

export const INSIGHTS_MAIN_PRESET_IDS: DailyPresetId[] = [
  'custom',
  'yesterday',
  'last_7_days',
  'last_14_days',
  'last_30_days',
  'last_year',
  'this_month',
  'this_quarter',
  'this_year',
];

// ── Comparison presets ────────────────────────────────────────────────────────

export const INSIGHTS_COMPARISON_PRESET_IDS: DailyComparisonPresetId[] = [
  'no_comparison',
  'custom',
  'previous_period',
  'previous_year_by_date',
  'previous_year_by_cal_week',
];
